// ════════════════════════════════════════════════════════════════════════
// skeleton-loader.js — SSOT del placeholder shimmer mientras carga contenido.
// Un solo keyframe (.skeleton-bar en 01-base.css), acá solo arma las formas
// (barra/fila/grid) para imitar la geometría de lo que va a aparecer.
// ════════════════════════════════════════════════════════════════════════

// Una barra individual. width acepta cualquier unidad CSS ('30%', '120px').
export function skeletonBar(width, height = '14px') {
    return `<div class="skeleton-bar" style="height:${height};width:${width};"></div>`;
}

// Una fila de barras en flex, separadas por gap — imita una fila de tabla/lista.
export function skeletonRow(widths, { height = '14px', gap = '10px', padding = '9px 10px' } = {}) {
    const barras = widths.map(w => skeletonBar(w, height)).join('');
    return `<div style="display:flex;gap:${gap};padding:${padding};">${barras}</div>`;
}

// N filas idénticas — atajo para tablas/listados cargando.
export function skeletonRows(widths, count, opts) {
    return Array(count).fill(skeletonRow(widths, opts)).join('');
}

// Grid de cards (KPIs/hero) con una barra adentro de cada una — imita tiles de resumen.
export function skeletonCardGrid(count = 4, { minWidth = '120px', barWidth = '70%' } = {}) {
    const card = `<div style="border:1px solid var(--border);border-radius:10px;padding:14px 12px;">${skeletonBar(barWidth)}</div>`;
    return `<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(${minWidth},1fr));gap:8px;margin-bottom:12px;">${Array(count).fill(card).join('')}</div>`;
}
